
import InvoiceAccountsController from "../../../../Controllers/AdminScreens/Invoices/Accounts/InvoiceAccountsController";
import React, { useState, useRef, useEffect } from 'react';
import Dropdown from "../../../../../Components/Dropdown";
import filterIcon from '../../../../../Assets/Icons/filter.png'
import leftBtuIcon from '../../../../../Assets/Icons/back.png'
import useManageGroupsController from '../../../../Controllers/AdminManagementScreens/TeamsAndUsers/ManageGroupsController';
import Loader from '../../../../../Components/Loader';
import { useNavigate } from "react-router-dom";
import search from '../../../../../Assets/Icons/search.png';
import TextInput from "../../../../../Components/TextInput";
import Input from "../../../../../Components/Input";
import leftArrowIcon from '../../../../../Assets/Icons/chevron-down.png'

const InvoiceAccountsScreen = () => {
  const navigator = useNavigate();


  const handleClientNameNavigate = (clientId) => {
    navigator('/invoice/client-info', { state: { clientId: clientId } })
  }

  const {
    currentAccountsList,
    getStatusStyle,
    setFilterValues,
    filterValues,
    handleFilterChange,
    handleSearchClient,
    searchLoading,
    searchError,
    clientList,
    searchUser,
    handleSearchInputText,
    handleSelectClient,
    listError, listLoading,
    clientTypeLoading,
    clientType,
    clientTypeError,
    handlePageChange,
    totalPages, visiblePages,
    currentPage,
    groupName,
    groupNameError,
    groupNameLoading,
    seriveError,
    servicesSearchList,
    serviceLoading,
    recipientOptions,
    userLoading,
    userError,
    applyFilters,
    cancelFilters,
    resetFilters, filterError,
    toggleFilters, showFilters
  } = InvoiceAccountsController()



  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div style={{ width: '93%', margin: 'auto' }}>
        <h3 style={styles.header}>
          <div style={styles.headerContainer}>
            <span>Accounts</span>
          </div>
        </h3>
      </div>
      <div className="tasksScreen-main-content">
        <div className="tasksScreen-tasks-container">
          <div className="tasksScreen-tasks-header" style={{ paddingBottom: 10 }}>
            <h2 className="tasksScreen-tasks-title">Search Clients</h2>
          </div>
          <div className="tasksScreen-filters-row" style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0px' }}>
            <div className="tasksScreen-filters-button-wrapper">
              <button style={styles.filterButton} onClick={toggleFilters}> <img src={filterIcon} alt="Filter" style={{ marginRight: '8px',width:12 }} />  <span>
                {showFilters ? 'Filters' : 'Filters'}
              </span></button>
            </div>
            <div style={{ paddingRight: '12px' }}>
              <img src={leftBtuIcon} style={{ marginRight: '5px', cursor: 'pointer', width: '28px', height: '28px' }} />
              <img src={leftBtuIcon} style={{ transform: 'rotate(180deg)', transition: 'transform 0.3s ease', cursor: 'pointer', width: '28px', height: '28px' }} />
            </div>
          </div>

          {showFilters && (
            <div className={`tasksScreen-filters-container ${showFilters ? 'tasksScreen-open-filters' : ''}`}>
              <div className="tasksScreen-filters">
                {/* Client Name Input */}
                <div className="filter-field">
                  <label>Client Name</label>

                  <TextInput
                    type="text"
                    placeholder="Client Name"
                    value={searchUser}
                    onChange={(e) => handleSearchInputText(e.target.value)}
                    onRightClick={handleSearchClient}
                    right={
                      searchLoading ? (
                        <Loader loading={searchLoading} color={'var(--primary-loader-color)'} size='small' /> // Show loader when loading
                      ) : (
                        <img src={search} alt="Search" style={{ cursor: 'pointer',height: '20px', width: '20px' }} />
                      )
                    }
                    style={{ padding: '20px 10px' }}
                    errorMessage={searchError}
                  />
                  {clientList.length > 0 && (
                    <ul style={styles.dropdownList}>
                      {clientList.map((client, index) => (
                        <li
                          key={client?.client_id}
                          onClick={() => handleSelectClient(client)}
                          style={{
                            ...styles.dropdownItem,
                            borderBottom: index !== clientList.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                          }}
                        >
                          {client?.client_name}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                <Dropdown
                  ref={(el) => (dropdownRefs.current["clientType"] = el)}
                  isOpen={openDropdown === "clientType"}
                  toggleDropdown={() => toggleDropdown("clientType")}
                  label="Client Type"
                  options={clientType} // Use the transformed dropdown options
                  value={filterValues?.clientType} // State for selected value
                  onChange={(value) => handleFilterChange("clientType", value)} // Handler for value change
                  errorMessage={clientTypeError}
                  width={260}
                  loading={clientTypeLoading}
                />

                <div className="filter-field">
                  <label>GSTIN No</label>
                  <Input
                    type="text"
                    placeholder="GSTIN No"
                    value={filterValues?.gstinNo}
                    onChange={(e) => handleFilterChange("gstinNo", e.target.value)}
                    maxLength={15}
                  />
                </div>

                {/* <Dropdown
                  ref={(el) => (dropdownRefs.current["pendingTask"] = el)}
                  isOpen={openDropdown === "pendingTask"}
                  toggleDropdown={() => toggleDropdown("pendingTask")}
                  label="Pending Task"
                  options={[
                    { "value": 1, "label": "Not Started" },
                    { "value": 2, "label": "In Progress" },
                    { "value": 3, "label": "Completed" },
                    { "value": 11, "label": "Reopen" },
                    { "value": 12, "label": "Issue" },
                    { "value": 13, "label": "Hold" }
                  ]}
                  value={filterValues?.pendingTask}
                  onChange={(value) => handleFilterChange("pendingTask", value)}
                /> */}
                <div className="filter-field">
                  <label>PAN No</label>
                  <Input
                    type="text"
                    placeholder="PAN No"
                    value={filterValues?.panNo}
                    onChange={(e) => handleFilterChange("panNo", e.target.value)}
                    maxLength={15}
                  />
                </div>

                <div className="filter-field">
                  <label>City</label>
                  <Input
                    type="text"
                    placeholder="City"
                    value={filterValues?.city}
                    onChange={(e) => handleFilterChange("city", e.target.value)}
                  />
                </div>


                <Dropdown
                  ref={(el) => (dropdownRefs.current["Assigned To"] = el)}
                  isOpen={openDropdown === "Assigned To"}
                  toggleDropdown={() => toggleDropdown("Assigned To")}
                  label="Assigned To"
                  placeholder="------"
                  value={filterValues?.assignedTo}
                  onChange={(value) => handleFilterChange("assignedTo", value)}
                  options={recipientOptions || []}
                  loading={userLoading}
                  errorMessage={userError}
                />


                <Dropdown
                  ref={(el) => (dropdownRefs.current["groupName"] = el)}
                  isOpen={openDropdown === "groupName"}
                  toggleDropdown={() => toggleDropdown("groupName")}
                  label="Group Name"
                  options={groupName} // Use the transformed dropdown options
                  value={filterValues?.groupName} // State for selected value
                  onChange={(value) => handleFilterChange("groupName", value)}
                  errorMessage={groupNameError}
                  loading={groupNameLoading}
                />

                <Dropdown
                  ref={(el) => (dropdownRefs.current["service"] = el)}
                  isOpen={openDropdown === "service"}
                  toggleDropdown={() => toggleDropdown("service")}
                  label="Services"
                  options={servicesSearchList || []}
                  value={filterValues?.services}
                  onChange={(value) => handleFilterChange("services", value)}
                  width={260}
                  loading={serviceLoading}
                  errorMessage={seriveError}
                />


              </div>
              <div>
              {filterError && <div className="list-error-msg" style={{ textAlign: 'left', paddingBottom: 5 }}> {filterError} </div>}
              <div className="button-container" style={{ marginBottom: '15px' }}>
                <button className="add-client-button" onClick={applyFilters} style={{ marginRight: '8px', paddingLeft: '30px', paddingRight: '30px', opacity: listLoading ? 0.5 : 1 }} disabled={listLoading}>
                  {listLoading && <span style={{ paddingRight: 5 }}> <Loader size='small' color='#FFFFFF' loading={listLoading} /> </span>} Apply</button>
                <button className="cancel-button" onClick={cancelFilters} style={{ border: '1px var(--button-bg-color) solid', borderRadius: '20px' }} >Cancel</button>
                <button className="cancel-button" onClick={resetFilters}>Reset</button>
              </div>
              </div>
            </div>
          )}
        </div>

        {currentAccountsList?.length > 0 &&
          <div className="tasksScreen-tasks-container" style={{ marginTop: 20 }}>
            <div className="tasksScreen-task-table-wrapper" >
              <table className="tasksScreen-task-table">
                <thead>
                  <tr>
                    <th style={{ width: "20%" }}>Client Name</th>
                    <th style={{ width: "8%" }}>Outstanding Amount</th>
                    <th style={{ width: "15%" }}>Client Type</th>
                    {/* <th style={{ width: "10%" }}>Created By</th> */}
                    <th style={{ width: "15%" }}>GSTIN No.</th>
                    <th style={{ width: "15%" }}>Group Name</th>
                    <th style={{ width: "12%" }}>Assigned To</th>
                    <th style={{ width: "15%" }}>Account Status</th>
                    {/* <th style={{ width: "5%" }}></th> */}
                  </tr>
                </thead>
                <tbody style={{ backgroundColor: "white" }}>
                  {currentAccountsList?.map((category, index) => (
                    <tr key={index}>
                      <td style={{ ...styles.tableLink, cursor: 'pointer' }} onClick={() => handleClientNameNavigate(category?.client_id)}>{category?.client_name}</td>
                      <td
                        style={{
                          ...styles.tableValue,
                          color: category?.outstanding_amount < 0 ? "red" : "",
                          textAlign: "right", // Align values to the right under the header
                        }}
                      >
                        {category?.outstanding_amount}
                      </td>
                      <td style={styles.tableValue}>{category?.client_type_name || '--'}</td>
                      <td style={styles.tableValue}>{category?.client_gstin || '--'}</td>
                      <td style={styles.tableValue}>{category?.group_name || '--'}</td>
                      <td style={styles.tableValue}>{category?.emp_id_incharge_name || '--'
                      }</td>
                      {/* <td style={styles.tableValue}>{category.createdby}</td> */}
                      <td style={styles.tableValue}>
                        {/* Status Label */}
                        <div
                          style={{
                            display: "inline-block", // Makes the div wrap content and have its own width
                            padding: "5px 5px", // Padding for the button-like appearance
                            borderRadius: "15px",
                            ...getStatusStyle(category?.account_status), // Dynamic styles based on the status
                            width: "auto", // Width adjusts automatically to content
                          }}
                        >
                          {category?.account_status}
                        </div>

                        {/* Action Buttons */}
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className="tasksScreen-table-footer" style={{ display: 'flex', alignItems: 'center', padding: '10px' }}>
              <span className="tasksScreen-pagination-info"
                style={{
                  whiteSpace: "nowrap",
                  // overflow: "hidden",
                  textOverflow: "ellipsis",
                }}>
                {`${currentPage}-${totalPages} of items`}
              </span>
              <div className="tasksScreen-pagination" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px', maxWidth: '100%' }}>
                <button
                  className="tasksScreen-pagination-button"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1 || totalPages === 0}
                >
                  <img
                    src={leftArrowIcon}
                    alt="Previous"
                    className="tasksScreen-arrow-left tasksScreen-icon-image"
                  />
                </button>
                {visiblePages.map((page) => (
                  <button
                    key={page}
                    className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
                    onClick={() => handlePageChange(page)}
                  >
                    {page}
                  </button>
                ))}
                <button
                  className="tasksScreen-pagination-button"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages || totalPages === 0}
                >
                  <img
                    src={leftArrowIcon}
                    alt="Next"
                    className="tasksScreen-arrow-right tasksScreen-icon-image"
                  />
                </button>
              </div>
            </div>
          </div>
        }

        {listLoading && <Loader loading={listLoading} color={'var(--primary-loader-color)'} />}
        {listError && <div className="list-error-msg">{listError} </div>}

      </div>
    </>

  )

};

const styles = {
  header: {
    fontSize: "22px",
    color: "#060606",
    marginBottom: "10px",
    fontWeight: 500,
    //   fontFamily:'Montserrat',
    //   marginLeft:'20px'
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center', // Vertically align items
  },
  searchFilterDiv: {
    padding: '15px 20px',
    marginBottom: '20px',
    borderRadius: '10px',
    //   borderBottomLeftRadius: '10px',
    //   borderLeft: '1px solid #9DC08B'
  },
  categoryHeader: {
    color: '#1F384C',
    fontSize: 28,
    // fontFamily:'Roboto Slab',
    fontWeight: 500,
    paddingBottom: 20
  },
  tableWrapper: {
    overflowX: "auto", // Horizontal scroll
    whiteSpace: "nowrap", // Prevent table from wrapping on small devices
    // marginBottom:50
  },
  tableValue: {
    colour: '#192A3E',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px'
  },
  tableLink: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px',
    textDecoration: 'underline',
    color: '#5A55D2'
  },
  container: {
    padding: "5px",
    backgroundColor: "#EFF0F4",
    border: "none",
    // borderRadius: "5px",
    border: '1px #EFF0F4 solid'
  },
  filtersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom: "15px",
  },
  filterButton: {
    backgroundColor: "white",
    color: "var(--button-bg-color)",
    border: "none",
    borderRadius: "5px",
    padding: "5px 8px",
    cursor: "pointer",
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    border: '1px var(--button-bg-color) solid'

  },
  filterIcon: {
    width: '10px',
    height: '10px',
    paddingRight: '5px'
  },

  paginationButtons: {
    display: "flex",
    gap: "5px",
  },
  paginationButton: {
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "5px 10px",
    cursor: "pointer",
  },
  filtersContainer: {
    // display: "flex",
    flexWrap: "wrap", // Wrap inputs to the next line if needed
    gap: "20px", // Space between inputs
    marginBottom: "15px",
    // justifyContent: "space-between", // Distribute inputs evenly
    border: '1px #EFF0F4 solid',
    padding: '10px'
  },
  buttonsContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  applyButton: {
    backgroundColor: "var(--button-bg-color)",
    color: "var(--button-text-color)",
    border: "none",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  cancelButton: {
    backgroundColor: "transparent",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  resetButton: {
    backgroundColor: "transparent",
    color: "#555",
    border: "none",
    cursor: "pointer",
  },
  dropdownList: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: '4px',
    maxHeight: '200px',
    overflowY: 'auto',
    zIndex: 1000,
    padding: 0, // Remove default padding
    margin: 0, // Remove default margin
    listStyleType: 'none', // Remove the dots
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee', // Default for all items
    backgroundColor: '#fff',
    hover: {
      backgroundColor: '#f0f0f0',
    },
  },


}

export default InvoiceAccountsScreen;